import { Box } from '@mui/material';
import React, { CSSProperties } from 'react';

type ImageProps = {
    src?: string | null;
    placeholder?: React.FC<React.SVGProps<SVGSVGElement>>;
    style?: CSSProperties;
    imageStyle?: CSSProperties;
    title?: string;
    onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
    onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
};

export const Image = ({
    src,
    placeholder,
    style,
    imageStyle,
    title,
    onError,
    onLoad,
}: ImageProps) => {
    const imageCss = {
        height: '100%',
        width: '100%',
        display: 'block',
        ...imageStyle,
    } as CSSProperties;

    const containerCss = {
        backgroundImage: `url(${placeholder})`,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        ...style,
    };

    return (
        <Box sx={containerCss}>
            {src && (
                <Box
                    component="img"
                    alt={title}
                    data-testid="image"
                    src={src}
                    title={title}
                    sx={imageCss}
                    onLoad={(event) => {
                        let parent = (event.target as HTMLElement)
                            .parentNode as HTMLElement;
                        parent.style.backgroundImage = 'none';
                        if (onLoad) {
                            onLoad(event);
                        }
                    }}
                    onError={(event) => {
                        if (onError) {
                            onError(event);
                        } else {
                            // @ts-ignore
                            event.target.style.display = 'none';
                        }
                    }}
                />
            )}
        </Box>
    );
};
